export const en = {
    error_title: 'Unfortunately, an error has occurred',
    error_description: 'We are already aware of the problem and will fix everything soon',
    already_registered_error_title: 'This company is already registered',
    solution_step_first: 'If you are an employee of this company, contact the travel coordinator of the company to get access',
    solution_step_second: 'If this is your company and you have not registered, contact support',
    find_company_title: 'We found you in 360',
    find_company_description: 'Please enter your company\'s INN and we will automatically upload the legal information. It is needed for ticket processing and preparation of documents',
};
